module.exports = __webpack_public_path__ + "facf55463ea04ba01b93be45d686a82e.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/video-active.png
 ** module id = 1555
 ** module chunks = 0
 **/